import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {Loadable} from "jotai/vanilla/utils/loadable";
import {Atom, WritableAtom} from "jotai";
import {AttachmentsQuery, getAttachments} from "../services/fieldService";
import {Attachment} from "../types/domain/attachment";

export const getAttachmentsLoadable = (
    companyId: string | null,
    query: AttachmentsQuery,
): [Atom<Loadable<Attachment[]>>, WritableAtom<Promise<Attachment[]>, [], void>] => {
    const atom = atomWithRefresh<Promise<Attachment[]>>(async () => {
        if (companyId) {
            return await getAttachments(companyId, query);
        } else {
            return await Promise.resolve([] as Attachment[]);
        }
    });

    return [loadable(atom), atom];
};
